export default "https://cdn-static.gokick.com/assets/9903fb7c557cf9d7d858f1d02aec0837d292f7c0/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";